'use client'

import _ from 'lodash'
import { forwardRef, useState } from 'react'
import { HiOutlineEye, HiOutlineEyeSlash } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

type Props = {
  className?: string
  label?: string
  name: string
  value?: string
  placeholder?: string
} & React.ComponentPropsWithoutRef<'input'>

export const Password = forwardRef<HTMLInputElement, Props>((props: Props, ref) => {
  const { className, id, name, label, onChange, onBlur } = props
  const [showPassword, setShowPassword] = useState(false)
  const errMsg = _.get(props, 'data-error')
  return (
    <div className='w-full'>
      <label htmlFor={id || name} className='form-label'>
        {label || 'Password'}
      </label>
      <div className='form-container mt-1 flex rounded'>
        <input
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          id={id || name}
          name={name}
          type={showPassword ? 'text' : 'password'}
          className={twMerge('form-default form-input rounded-r-none!', className, errMsg && 'form-input-error')}
          aria-label={props['aria-label'] || (typeof label === 'string' ? label : 'Password')}
        />
        <button tabIndex={-1} type='button' className='form-addon-button' onClick={() => setShowPassword(!showPassword)}>
          {showPassword ? <HiOutlineEyeSlash className='size-5' /> : <HiOutlineEye className='size-5' />}
        </button>
      </div>
      {errMsg && <div className='form-error-message'>{errMsg}</div>}
    </div>
  )
})
